import { initializeProducts, initializeProductsVariant } from 'embed/initProducts'

const initState = {
  userSettings: {},
  products: [],
  products_variant_stock: {},
  data: {},
  popupTrigger: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS':
      return {
        ...state,
        ...{ products: initializeProducts(state.data, state.userSettings) }
      }
    case 'SET_PRODUCTS_VARIANT_STOCK':
      return {
        ...state,
        ...{ products_variant_stock: initializeProductsVariant(state.data, state.userSettings) }
      }
    case 'SET_DATA':
      const userSettings = JSON.parse(action.data.settings)
      return {
        ...state,
        ...{
          data: action.data,
          products: initializeProducts(action.data, userSettings),
          products_variant_stock: initializeProductsVariant(action.data, userSettings),
          userSettings
        }
      }
    case 'SET_POPUP_TRIGGER':
      return {
        ...state,
        ...{ popupTrigger: action.trigger }
      }
    default:
      return state
  }
}
